import { SignIn, SignUp } from "@clerk/clerk-react";
import { Box, Grid, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { routes } from "schemas/routes";

import { AuthAction } from "features/Auth/schema";

import { getRedirectUrl } from "../../helpers";
import { LIGHT_PINK, MAIN_BLUE } from "../styles";

interface Props {
  action: AuthAction;
}

const PitchPleaseAuth = ({ action }: Props) => {
  const location = useLocation();
  const signInUrl = "/pitch-please/sign-in";
  const signUpUrl = "/pitch-please/sign-up";
  const redirectUrl = getRedirectUrl(routes.pitchPlease, location);

  const appearance = {
    elements: {
      card: {
        boxShadow: "none",
      },
    },
    variables: {
      colorPrimary: MAIN_BLUE,
    },
  };

  return (
    <Box sx={{ py: 3 }}>
      <Typography textAlign={"center"} gutterBottom>
        <Box
          component="span"
          sx={{ fontSize: { xs: 20, md: 30 }, color: LIGHT_PINK }}
        >
          Create a Bento Account
        </Box>
      </Typography>
      <Typography sx={{ mb: 3 }} textAlign={"center"}>
        If you already have a Bento Account, simply login{" "}
      </Typography>

      <Grid container justifyContent="center">
        {action === AuthAction.SIGN_UP && (
          <SignUp
            appearance={appearance}
            signInUrl={signInUrl}
            afterSignUpUrl={redirectUrl}
            afterSignInUrl={redirectUrl}
          />
        )}
        {action === AuthAction.SIGN_IN && (
          <SignIn
            appearance={appearance}
            signUpUrl={signUpUrl}
            afterSignUpUrl={redirectUrl}
            afterSignInUrl={redirectUrl}
          />
        )}
      </Grid>
    </Box>
  );
};

export default PitchPleaseAuth;
